// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"63ca782d","240":"54dc9d22","565":"964bdf5b","574":"6ed51ac5","638":"69695b9b","718":"98d98935"}[chunkId] + ".chunk.css";
};